import Box from "@galaxy-io/dls/layout/Box";
import Tabs from "@galaxy-io/dls/navigation/Tabs";
import { t } from "@galaxy-io/dls/theme/tokens/t";
import { styled } from "@linaria/react";
import type { ReactNode } from "react";
import { Link } from "@/app/navigation";

export const SettingsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${t.space[24]};
  width: 100%;
  max-width: 1280px;
  padding: ${t.space[24]} var(--gtm-page-inset, ${t.space[24]}) ${t.space[32]};
  min-width: 0;

`;
const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${t.space[12]};
  min-width: 0;
  width: 100%;
  scroll-margin-top: 16px;
`;
export function SettingsSection({
  id,
  title,
  children,
}: {
  id: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <Section id={id} aria-label={title}>
      {children}
    </Section>
  );
}

export function SettingsTabs({ workspace, isAdmin }: { workspace: boolean; isAdmin: boolean }) {
  return (
    <Box padding={[0, 12]}>
      <Tabs
        as={Link}
        ariaLabel="Settings sections"
        value={workspace ? "workspace" : "user"}
        items={[
          { id: "user", label: "User", href: "/settings/preferences" },
          ...(isAdmin ? [{ id: "workspace", label: "Workspace", href: "/settings/members" }] : []),
        ]}
      />
    </Box>
  );
}

export const SettingsActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row-reverse;
  gap: ${t.space[8]};
  min-width: 0;
`;

export const AccountGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: start;
  gap: ${t.space[24]};
  @media (max-width: 900px) { grid-template-columns: minmax(0, 1fr); }
`;
export const SettingsFacts = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${t.space[16]};
`;
